enum AiWordCount {
  SHORT = "short",
  MEDIUM = "medium",
  LARGE = "large",
}

export default AiWordCount;
